import React, { useCallback, useEffect, useState } from "react";
import "./Landing.css";
import { makeStyles, Persona, Tab, TabList } from "@fluentui/react-components";
import {
    Button,
    tokens,
    typographyStyles,
} from "@fluentui/react-components";
import NavigationButtons from "./NavLanding/NavigationButtons";
import PinnedButtons from "./NavLanding/Pinned";
  import AllAppsButtons from "./NavLanding/AllApps";
import { ArrowDownload16Filled, History16Regular, Send16Filled } from "@fluentui/react-icons";

const useClasses = makeStyles({
    carousel: {
        display: "grid",
        gridTemplateColumns: "1fr max-content 1fr",
        gap: "10px",
        placeItems: "center",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    test: {
      ...typographyStyles.largeTitle,
      alignContent: "center",
      borderRadius: tokens.borderRadiusLarge,
      height: "200px",
      textAlign: "center",
    },
    footer: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "10px",
    },
    code: {
      justifyContent: "end",
      backgroundColor: tokens.colorNeutralBackground4,
      borderRadius: tokens.borderRadiusLarge,
      fontFamily: tokens.fontFamilyMonospace,
      fontSize: tokens.fontSizeBase400,
      padding: "10px",
      placeSelf: "end",
    },
    controls: {
      alignSelf: "center",
      display: "flex",
      gap: "10px",
    },
    control: {
      minWidth: "32px",
    },
  });
const useStyles = makeStyles({
  root: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    rowGap: "20px",
  },
  floatingButton: {
    position: "sticky",
    bottom: "50px",
    right: "100px",
    zIndex: 1000,
    backgroundColor: "#a3d3f9",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    
  },
});

interface Message {
  message: string;
  id: number;
}

interface User {
  email: string;
  phoneNumber: string;
  token: string;
}

type Props = {
  message?: Message;
  user?: User;
  [key: string]: any; // Allows additional props dynamically
};

const CustomButton = [
  { label: "Receive", icon: <ArrowDownload16Filled />, path: "/prompts" },
  { label: "Send", icon: <Send16Filled />, path: "/notifications" },
  { label: "History", icon: <History16Regular />, path: "/history" },
  { label: "History", icon: <History16Regular />, path: "/settings" },
]

const AllApps: React.FC<Props> = (props) => {
    const styles = useStyles();
    const [activeIndex, setActiveIndex] = React.useState(0);
    const classes = useClasses();
    const autoSlideInterval = 3000;
    const { message, user } = props;

    

    return (
        <>
        <div className="xK7As J_3wQ">
           
              <div className="HKfrs JbtCF">
                <div className="kuefK">           
                <NavigationButtons buttons={[]} />
                <PinnedButtons />
                <AllAppsButtons />
               </div>
             </div>
        </div>
        </>
    )
}

export default AllApps;